import { incbotFeedbackData, incScreenFeedbackData } from "../../utils/helper";
import {
  GET_INTERVIEW,
  GET_INTERVIEW_FAILURE,
  GET_INTERVIEW_SUCCESS,
  GET_FEEDBACK,
  GET_FEEDBACK_SUCCESS,
  GET_FEEDBACK_FAILURE,
} from "../action/types";
import { ActionType, IncbotFeedbackState, RootState } from "../types";

const INIT_STATE: IncbotFeedbackState = {
  profileForm: null,
  feedbackForm: null,
  interviewResult: null,
  showSoftSkills: {},
  showFinalRemarks: {},
  loading: false,
  fetchingWhiteLabelStatus: false,
  fullyConversational: false,
  whiteLabelLogos: {
    whiteLogo: "",
    logo: "",
  },
  apiFailure: null,
};

const Interview = (
  state: IncbotFeedbackState = INIT_STATE,
  action: ActionType
): IncbotFeedbackState => {
  switch (action.type) {
    case GET_INTERVIEW:
    case GET_FEEDBACK:
      return {
        ...state,
        loading: true,
        feedbackForm: null,
        fetchingWhiteLabelStatus: true,
      };

    case GET_INTERVIEW_SUCCESS: {
      const interviewData = action.payload;
      const {
        profile,
        feedback = { status: false },
        permissions,
        psychometricSkills
      } = incbotFeedbackData(interviewData);

      return {
        ...state,
        loading: false,
        fetchingWhiteLabelStatus: false,
        profileForm: profile,
        feedbackForm: feedback,
        interviewResult: interviewData,
        showSoftSkills: permissions.softSkills,
        showFinalRemarks: permissions.finalRemarks,
        fullyConversational: interviewData?.question?.fullyConversational || false,
        whiteLabelLogos: interviewData?.employer?.checkWhiteLabelledStatus?.whiteLabelStatus
          ? {
              whiteLogo:
                interviewData?.employer?.checkWhiteLabelledStatus?.data?.companyWhiteLogo || "",
              logo: interviewData?.employer?.checkWhiteLabelledStatus?.data?.companyLogo || "",
            }
          : { whiteLogo: "", logo: "" },
        csatSubmission: interviewData?.csatSubmission ?? false,
        psychometricSkills 
      };
    }

    case GET_INTERVIEW_FAILURE:
    case GET_FEEDBACK_FAILURE:
      return {
        ...state,
        loading: false,
        feedbackForm: { status: false },
        fetchingWhiteLabelStatus: true,
        apiFailure: GET_INTERVIEW, // Consider dynamic mapping if you want accurate action source
      };

    case GET_FEEDBACK_SUCCESS: {
      const feedbackData = action.payload;
      const { profile, feedback = { status: false } } = incScreenFeedbackData(feedbackData);

      return {
        ...state,
        loading: false,
        fetchingWhiteLabelStatus: false,
        profileForm: profile,
        feedbackForm: feedback,
        interviewResult: feedbackData,
        whiteLabelLogos: feedbackData?.employer?.checkWhiteLabelledStatus?.whiteLabelStatus
          ? {
              whiteLogo:
                feedbackData?.employer?.checkWhiteLabelledStatus?.data?.companyWhiteLogo || "",
              logo: feedbackData?.employer?.checkWhiteLabelledStatus?.data?.companyLogo || "",
            }
          : { whiteLogo: "", logo: "" },
        csatSubmission: feedbackData?.csatSubmission ?? false,
      };
    }

    default:
      return state;
  }
};

export default Interview;

// Selectors
export const getProfileForm = (state: RootState) => state.IncbotFeedback.profileForm;

export const getFeedbackForm = (state: RootState) => state.IncbotFeedback.feedbackForm;
export const getPsychometricSkills = (state: RootState) => state.IncbotFeedback.psychometricSkills;

/** Full API result from getInterview (ratingSystem, position, question, candidate, feedback, user, etc.) */
export const getInterviewResult = (state: RootState) => state.IncbotFeedback.interviewResult;

export const getShowSoftSkills = (state: RootState) => state.IncbotFeedback.showSoftSkills;

export const getShowFinalRemarks = (state: RootState) => state.IncbotFeedback.showFinalRemarks;

export const getWhiteLabelLogos = (state: RootState) => state.IncbotFeedback.whiteLabelLogos;

export const getConversationalStatus = (state: RootState) =>
  state.IncbotFeedback.fullyConversational;

export const getCsatSubmission = (state: RootState) => state.IncbotFeedback.csatSubmission ?? false;

export const getLoading = (state: RootState) => state.IncbotFeedback.loading;
